import { setInnCode } from "components/app/App.slice";
import Typography from "components/common/Typography";
import InncodeDropDown from "components/common/dropdowns/InncodeDropDown";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import GlobalSearch from "../GlobalSearch";
import { setSkipUseEffect } from "../ReleaseHighlight/ReleaseHighlights.slice";
import { reset } from "./HotelUserDashboard.slice";

const InnCodeWrapper = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const urlParams = new URLSearchParams(window.location.search);

  const isConsultant = useAppSelector((state) => state.app.loggedInUserDetails.isConsultant);
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const { isAbovePropertyUserFetched, isAbovePropertyUser, isLeadership } = useAppSelector(
    (state) => state.app.loggedInUserDetails
  );
  const isHotelUser = !isCorp && !isConsultant && !isAbovePropertyUser && isAbovePropertyUserFetched;

  const isHome = location.pathname === "/";

  const inncodeParam = urlParams.get("inncode");

  const handleOnChange = async (value: string) => {
    const inncodeValue = localStorage.getItem("innCode");
    if (inncodeValue !== value) {
      dispatch(setInnCode(value));
      dispatch(reset());
      localStorage.setItem("innCode", value);
    }
    const payload = {
      filter: {
        innCodes: [value]
      },
      fetchLatest: false
    };
    dispatch(setSkipUseEffect(true));
  };

  useEffect(() => {
    if (inncodeParam) {
      handleOnChange(inncodeParam);
    }
  }, []);

  return (
    <div className="page-title-wrapper">
      <div className="home-title">
        <Typography showBold variant="h3" color={tokens.Text.General.Secondary}>
          Home
        </Typography>
      </div>
      <div className="ask-boost-container global-search-mobile">
        {isHome && !isCorp && !isConsultant && ((isHotelUser && isLeadership) || isAbovePropertyUser) && (
          <GlobalSearch />
        )}
      </div>
      {location.pathname.split("/")[1] !== "userDashboard" && (
        <div className="inncode-wrapper">
          <Typography variant="body2" color={tokens.Text.General.Secondary}>
            Inncode
          </Typography>
          <InncodeDropDown
            className="inn-code-dropdown"
            backgroundColor={"#686B8C"}
            height="24px"
            color={tokens.Text.General.Inverse}
            isCorp={isCorp}
            value={innCode || "undefined"}
            onChange={handleOnChange}
          />
        </div>
      )}
    </div>
  );
};

export default InnCodeWrapper;
